import api from 'api';
import { currency } from 'functions';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

const Summary = ({
  offer,
  product,
  discounts,
  paymentMethod,
  totalPrice,
  orderBumps,
  selectedPlan,
  coupon,
  setCoupon,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState(false);
  const { uuidOffer } = useParams();

  const calculateDiscount = () => {
    return (totalPrice * discounts[paymentMethod]) / 100;
  };
  const calculateCoupon = () => {
    const amount = (offer.price * coupon.percentage) / 100;
    return Math.floor(amount * 100) / 100;
  };
  let totalPriceFinal = offer.prices[paymentMethod];

  if (coupon && coupon.percentage) {
    totalPriceFinal = totalPriceFinal - (offer.price * coupon.percentage) / 100;
  }

  orderBumps.forEach((item) => {
    if (item.quantity > 0) {
      totalPriceFinal += item.prices[paymentMethod] * item.quantity;
    }
  });

  const applyCoupon = (e) => {
    e.preventDefault();
    if (!inputValue) {
      setError(true);
    } else {
      setError(false);
      api
        .get(`offers/${uuidOffer}/coupon/${inputValue}`)
        .then((r) => {
          if (r.data === false) {
            setError(true);
            setCoupon(null);
          } else {
            setCoupon(r.data);
          }
        })
        .catch((e) => {
          setError(true);
          setCoupon(null);
        });
    }
  };

  return (
    <>
      {discounts && selectedPlan !== null && (
        <>
          {offer.hasActiveCoupon && (
            <Row>
              <Col md={6} className='d-flex mb-3 pr-0'>
                <div className='input-group'>
                  <div className='d-flex area'>
                    <label htmlFor='test'>
                      <i className='las la-tags'></i>
                    </label>
                    <input
                      type='text'
                      name='coupon'
                      className='form-control'
                      placeholder='Cupom de desconto'
                      onChange={(e) => {
                        e.preventDefault();
                        setInputValue(e.target.value);
                      }}
                    />
                    <button
                      className='btn btn-primary coupon-btn'
                      onClick={applyCoupon}
                    >
                      Aplicar
                    </button>
                  </div>
                  {error && <div className='input-error'>Cupom inválido</div>}
                </div>
              </Col>
            </Row>
          )}
          <div className='summary'>
            <div className='title'>Produtos da sua compra:</div>
            <ul>
              <li className='item'>
                <div className='d-flex w-100 justify-content-between'>
                  <div className='product'>
                    <span className='title m-0'>{offer.offer.name}</span>
                  </div>

                  <span className='payment-details'>
                    {offer.price
                      ? currency(offer.price)
                      : `${currency(selectedPlan.price)} / ${
                          selectedPlan.frequency_label
                        }`}
                  </span>
                </div>
                {offer.quantity > 1 && (
                  <div className='ml-auto'>
                    <div className='quantity-small'>
                      quantidade: {offer.quantity}
                    </div>
                  </div>
                )}
              </li>

              {orderBumps.map((item) => {
                return (
                  <React.Fragment key={item.uuid}>
                    {item.quantity > 0 && (
                      <>
                        {item.product.type === 'physical' ? (
                          <li className='item'>
                            <div className='d-flex w-100 justify-content-between'>
                              <div className='product'>
                                <span className='title m-0'>
                                  {item.product.name}
                                </span>
                              </div>
                              <div>
                                <span className='payment-details'>
                                  {currency(item.price * item.quantity)}
                                </span>
                                <div className='ml-auto'>
                                  <div className='quantity-small'>
                                    quantidade: {item.quantity}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ) : (
                          <li className='item'>
                            <div className='d-flex w-100 justify-content-between'>
                              <div className='product'>
                                <span className='title m-0'>
                                  {item.product.name}
                                </span>
                              </div>
                              <span className='payment-details'>
                                {currency(item.price)}
                              </span>
                            </div>
                          </li>
                        )}
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
          {discounts && discounts[paymentMethod] > 0 && (
            <>
              <div className='subtotal-box'>
                <span>Sub-total</span>
                <span className='text-decoration-line-through'>
                  {currency(totalPrice)}
                </span>
              </div>
              <div className='discount-box'>
                <span>Desconto de {discounts[paymentMethod]}%</span>
                <span>{currency(calculateDiscount() * -1)}</span>
              </div>
            </>
          )}
          {coupon && (
            <div className='discount-box'>
              <span>Cupom de {coupon.percentage}%</span>
              <span>{currency(calculateCoupon() * -1)}</span>
            </div>
          )}
          {product.type === 'physical' && (
            <div className='subtotal-box'>
              <span>Frete</span>
              {product.type === 'physical' && offer.shipping_type === 0 && (
                <span>GRÁTIS</span>
              )}
              {product.type === 'physical' && offer.shipping_type === 1 && (
                <span>{currency(offer.shipping_price)}</span>
              )}
            </div>
          )}
          <div className='total-box'>
            <span>Total</span>
            <span>
              {selectedPlan
                ? `${currency(selectedPlan.price)} / ${
                    selectedPlan.frequency_label
                  } ${totalPriceFinal ? `+ ${currency(totalPriceFinal)}` : ''}`
                : `${currency(totalPriceFinal + offer.shipping_price)}`}
            </span>
          </div>
        </>
      )}
    </>
  );
};

export default Summary;
